<template>
    <md-table-cell class="text-center" >
        <span v-if="this.bool" class="md-tag md-tag-success">Active</span>
        <span v-else class="md-tag md-tag-danger">Inactive</span>
    </md-table-cell>
</template>

<script>
    export default {
        name: "IndexTableCellBool",
        props: {
            bool: {
                type: Boolean,
                required: true,
            }
        }
    }
</script>

<style scoped>

</style>